import { BrandMap } from "./BrandMap";
import { IBrand } from "./IBrand";

export type CategoryMap = Map<string, CategoryMapItem>;

export type CategoryMapItem = {
  categoryName: string;
  subCategories: {
    categoryName: string;
    naicsCode: string;
    brands: Map<string, IBrand>;
  }[];
};
